<mat-card>
  <!-- Loading spinner -->
  <div *ngIf="!componentReady || !translationsLoaded" class="loading-container">
    <mat-spinner diameter="40" class="loading-spinner"></mat-spinner>
  </div>

  <form [formGroup]="form" (ngSubmit)="onFormSubmit()" *ngIf="componentReady && translationsLoaded">
    <sn-brand-logo type="horizontal" class="logo-container"></sn-brand-logo>

    <!-- Server error messages -->
    <sn-alert
      dense
      type="danger"
      class="alert-no-radius"
      *ngIf="form.errors && !form.errors['passwordMismatch']"
    >
      <div *ngFor="let error of form.errors | keyvalue">
        <b>{{ toStartCase(error.key) }}</b
        >:
        <ul class="margin-bottom">
          <li *ngFor="let item of error.value">{{ item }}</li>
        </ul>
      </div>
    </sn-alert>

    <main class="main-content">
      <h3 class="title-text">{{ 'account.dialogs.changePassword.title' | t }}</h3>

      <!-- Password requirements -->
      <div class="password-requirements">
        <h4 class="requirements-title">{{ 'account.dialogs.changePassword.passwordRequirements' | t }}</h4>
        <ul class="requirements-list">
          <li>{{ 'account.dialogs.changePassword.rules.minLength' | t }}</li>
          <li>{{ 'account.dialogs.changePassword.rules.alphanumeric' | t }}</li>
          <li>{{ 'account.dialogs.changePassword.rules.notSimilarToUser' | t }}</li>
          <li>{{ 'account.dialogs.changePassword.rules.notCommon' | t }}</li>
          <li>{{ 'account.dialogs.changePassword.rules.noReuse' | t }}</li>
        </ul>
      </div>

      <!-- Authentication Code field -->
      <div class="field-container">
        <h4 class="requirements-title">{{ 'account.dialogs.changePassword.authenticationCode.label' | t }}</h4>
        <p class="auth-code-message">
          {{ 'account.dialogs.changePassword.authenticationCode.message' | t }}
        </p>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'account.dialogs.changePassword.authenticationCode.label' | t }}</mat-label>
          <input matInput formControlName="authenticationCode" />
          <mat-error *ngIf="form.get('authenticationCode').hasError('required')">
            {{ 'account.dialogs.changePassword.authenticationCode.required' | t }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- New Password field -->
      <div class="field-container">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'account.dialogs.changePassword.newPassword.label' | t }}</mat-label>
          <input
            matInput
            [type]="hideNewPassword ? 'password' : 'text'"
            formControlName="newPassword"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hideNewPassword = !hideNewPassword"
            [attr.aria-label]="'account.dialogs.changePassword.toggleVisibility' | t"
            [attr.aria-pressed]="!hideNewPassword"
          >
            <mat-icon>{{ hideNewPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
          <mat-error *ngIf="form.get('newPassword').hasError('required')">
            {{ 'account.dialogs.changePassword.newPassword.required' | t }}
          </mat-error>
          <mat-error *ngIf="form.get('newPassword').hasError('minlength')">
            {{ 'account.dialogs.changePassword.newPassword.minLength' | t }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Confirm Password field -->
      <div class="field-container">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'account.dialogs.changePassword.newPassword.confirmPassword' | t }}</mat-label>
          <input
            matInput
            [type]="hideConfirmPassword ? 'password' : 'text'"
            formControlName="confirmPassword"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hideConfirmPassword = !hideConfirmPassword"
            [attr.aria-label]="'account.dialogs.changePassword.toggleVisibility' | t"
            [attr.aria-pressed]="!hideConfirmPassword"
          >
            <mat-icon>{{ hideConfirmPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
          <mat-error *ngIf="form.get('confirmPassword').hasError('required')">
            {{ 'account.dialogs.changePassword.confirmPassword.required' | t }}
          </mat-error>
          <mat-error *ngIf="form.get('confirmPassword').hasError('passwordMismatch')">
            {{ 'account.dialogs.changePassword.confirmPassword.mismatch' | t }}
          </mat-error>
        </mat-form-field>
      </div>
    </main>

    <mat-card-actions class="submit-container">
      <button
        mat-flat-button
        type="submit"
        color="accent"
        [mtBasicSpinner]="isLoading"
        [disabled]="form.invalid"
      >
        {{ 'account.dialogs.changePassword.submitButton' | t }}
      </button>
    </mat-card-actions>
  </form>
</mat-card>
